import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import {
  installConsoleRedirect,
  installGlobalErrorHandlers,
} from './utils/helpers/logger.helper';

installConsoleRedirect();
installGlobalErrorHandlers();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container element #root was not found.');
}

const root = createRoot(container);

root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
